<template>
  <div>
    <table
      v-if="notesList.length != 0"
      class="table"
      style="table-layout:fixed;"
    >
      <thead>
        <tr>
          <th style="width:23%">Title</th>
          <th style="width: 60%;">Description</th>
          <th>Report Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in notesList"
          :key="item.id"
          :class="index % 2 == 0 ? 'even' : ''"
        >
          <td valign="top" width="15%">
            <div>
              {{ item.title }}
              <p
                v-if="item.type"
                style="text-transform:capitalize"
                class="label label-info"
              >
                {{ showResource(item.type) }}
              </p>
            </div>
          </td>
          <td v-if="index == 0" v-html="item.description"></td>
          <td v-else>
            <div>
              <p>
                {{ item.plain_description | truncate(250, index)
                }}<a
                  v-if="checkLength(item.plain_description, index)"
                  href="javascript:void(0)"
                  @click="showInlinePopup(item)"
                  >...Show More</a
                >
              </p>
            </div>
          </td>
          <td width="10%">{{ parseDate(item.modified_description_date) }}</td>
          <td class="row-add-edit">
            <div class="row-add-edit">
              <a
                href="javascript:void(0)"
                class="item-add-edit"
                data-toggle="dropdown"
              ></a>
              <div
                class="dropdown-menu remove-style"
                aria-labelledby="dropdownMenuButton"
              >
                <a class="grid-item ico-edit" @click="editItem(item)">Edit</a>
                <a class="grid-item ico-activity" @click="viewDetail(item)"
                  >View Detail</a
                >
                <a class="grid-item ico-recommended" @click="copyLink(item)"
                  >Copy Link</a
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <NoDataAvailable
      displayMessage="No Data Available"
      v-else
    ></NoDataAvailable>

    <CopyReleaseLink
      :item="selectedItem"
      @resetAction="resetAction"
      :title="title"
    />
    <ShowDescriptionPoUp
      @resetdescription="resetdescription"
      :selectedDescription="selectedDescription"
      :title="title"
    />
  </div>
</template>

<script>
import NoDataAvailable from "../NoDataAvailable.vue";
import CopyReleaseLink from "./CopyReleaseLink.vue";
import ShowDescriptionPoUp from "./ShowDescriptionPoUp.vue";
var moment = require("moment");

export default {
  name: "ReleaseNotesListGrid.vue",
  props: [],
  components: { moment, NoDataAvailable, CopyReleaseLink, ShowDescriptionPoUp },
  data() {
    return {
      selectedItem: -1,
      title: "",
      selectedDescription: "",
      title: "",
    };
  },
  filters: {
    truncate: function(data, charLength, index) {
      // let text = (new DOMParser).parseFromString(data, "text/html").documentElement.textContent;
      // text = text.split(/\s{2,}/)
      // text = text.join(', ')
      if (index == 0) {
        return data;
      } else {
        if (data.length <= 250) {
          return data;
        } else {
          data = data.substr(0, 250);
          return data;
          // let parsed_text = '<p>'+ text + '....' + `<a href="javascript:void(0)"  onclick="this.showInlinePopup()">Show More</a>` + '</p>'
          // return parsed_text
        }
      }
    },
  },
  computed: {
    notesList: {
      set(val) {
        this.$store.commit("release/setNotesList", val);
      },
      get() {
        return this.$store.state.release.notesList;
      },
    },
  },
  mounted() {},
  methods: {
    parseDate(data) {
      return moment(data).format("MM/DD/YYYY");
      //return data;
    },
    parseToHTML(data) {
      $("#table-row-add").append(data);
    },
    viewDetail(item) {
      let path = "/releaseDetail" + "/detail/" + item.id;
      this.$router.push({ path: path });
    },
    copyLink(item) {
      this.selectedItem = item.id;
      this.title = item.title;
      $("#copyLink").modal("show");
    },
    resetAction() {
      $("#copyLink").modal("hide");
    },
    editItem(item) {
      let path = "/addNote" + "/" + item.id;
      this.$router.push({ path: path });
    },
    showInlinePopup(item) {
      this.selectedDescription = item.description;
      this.title = item.title;
      $("#descriptionPopUp").modal("show");
    },
    resetdescription() {
      this.selectedDescription = "";
      this.title = "";
      $("#descriptionPopUp").modal("hide");
    },
    checkLength(item, index) {
      if (index == 0) {
        return false;
      } else {
        if (item.length > 250) {
          return true;
        } else {
          return false;
        }
      }
    },
    showResource(data) {
      if (data) {
        return data;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
.table-release-responsive {
  .table {
    td {
      vertical-align: top !important;
    }
  }
}
</style>
